import Exception from "../utilities/Exception";
import config from "config";
import { prune } from "utilities/utilities";
import history from "utilities/history";
import { rootStore } from "stores/RootStore";

export default class API {
  static post(relativeUrl: string, body = null, type = "json") {
    return new Promise((resolve, reject) => {
      let headers = API._getInit("POST", type);
      if (body) {
        if (type === "json") {
          headers.body = JSON.stringify(prune(body));
        } else if (type === "form-urlencoded") {
          headers.body = Object.keys(body)
            .map(key => {
              return (
                encodeURIComponent(key) + "=" + encodeURIComponent(body[key])
              );
            })
            .join("&");
        } else {
          headers.body = body;
        }
      }
      fetch(`${config.API_BASE_URL}${relativeUrl}`, headers)
        .then(response => {
          if (response.ok) {
            resolve(response.status === 204 ? null : response.json());
          } else {
            API._handleError(response, reject);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static delete(relativeUrl: string, type = "json") {
    return new Promise((resolve, reject) => {
      let headers = API._getInit("DELETE", type);
      fetch(`${config.API_BASE_URL}${relativeUrl}`, headers)
        .then(response => {
          if (response.ok) {
            resolve(response.json());
          } else {
            API._handleError(response, reject);
          }
        })
        .catch(err => {
          throw new Exception(err);
        });
    });
  }

  static patch(relativeUrl: string, body = null) {
    return new Promise((resolve, reject) => {
      let headers = API._getInit("PATCH");
      if (body) {
        headers.body = JSON.stringify(prune(body));
      }
      fetch(`${config.API_BASE_URL}${relativeUrl}`, headers)
        .then(response => {
          if (response.ok) {
            resolve(response.json());
          } else {
            API._handleError(response, reject);
          }
        })
        .catch(err => {
          throw new Exception(err);
        });
    });
  }

  static put(relativeUrl: string, body = null) {
    return new Promise((resolve, reject) => {
      let headers = API._getInit("PUT");
      if (body) {
        headers.body = JSON.stringify(body);
      }
      fetch(`${config.API_BASE_URL}${relativeUrl}`, headers)
        .then(response => {
          if (response.ok) {
            resolve(response.json());
          } else {
            API._handleError(response, reject);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static get(relativeUrl: string) {
    return new Promise((resolve, reject) => {
      let headers = API._getInit("GET");
      fetch(`${config.API_BASE_URL}${relativeUrl}`, headers)
        .then(response => {
          if (response.ok) {
            resolve(response.json());
          } else {
            API._handleError(response, reject);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  static _getInit(method, type = "json") {
    let token = "";
    try {
      token = rootStore.auth.token;
    } catch (e) {}

    let options = {
      method: method,
      headers: {
        Authorization: token
      }
    };

    if (type === "json") {
      options.headers = {
        ...options.headers,
        "Content-Type": "application/json",
        Accept: "application/json"
      };
    } else if (type === "form-urlencoded") {
      options.headers = {
        ...options.headers,
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json"
      };
    }
    return options;
  }

  static _handleError(response, reject) {
    if (response.status === 401) {
      rootStore.auth.clearCredentials();
      history.push("/login");
      reject("Unauthorized");
      return;
    }
    response.json().then(err => {
      reject(err.error ? err.error : err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js